import React from 'react';
import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { onboardingWelcome as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    getWelcomeText: (storeCount) =>
      <>Here are a few tips for earning the most miles <span>when you shop at over {storeCount} stores.</span></>,
    welcomeCTAText: 'Get started',
    getWelcomeTitleText: (userName) => <>Welcome{userName ? `, ${userName}` : ''}</>,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
